import {useEffect, useState} from 'react';

import {
  useTracker as useTrackerSnitch,
  eventTypes,
  actionNames,
} from '@newsela/snitch';

const useTrackPageView = () => {
  const {trackAction, getEventName} = useTrackerSnitch();
  const [currentPathname, setCurrentPathname] = useState(
    window.location.pathname
  );

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPathname(window.location.pathname);
    };

    // Handle back/forward navigation
    const handlePopstate = () => {
      handleLocationChange();
    };

    // Override pushState and replaceState to catch programmatic navigation
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(...args) {
      originalPushState.apply(history, args);
      handleLocationChange();
    };

    history.replaceState = function(...args) {
      originalReplaceState.apply(history, args);
      handleLocationChange();
    };

    window.addEventListener('popstate', handlePopstate);

    // Initial check
    setCurrentPathname(window.location.pathname);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
      // Restore original methods
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  useEffect(() => {
    trackAction({
      event_type: eventTypes.pageView,
      event_name: getEventName(null, null, actionNames.pageView),
      dimension_properties: {
        description: 'Page view.',
      },
    });
  }, [currentPathname]);
};

export default useTrackPageView;
